import React from 'react';
import { usePathname } from '@framework/next/navigation';
import dataroomUrl from '@/dataroom/infrastructure/dataroomUrl';
import { useDataroomTenantContext } from '@dataroom/tenant/DataroomTenantContext';
import GetStartedButtonComponent from '@framework/ui/Pages/Landing/Sections/GetStartedButton';

interface IProps {
  title?: string,
  className?: string,
}

const GetStartedButton = ({ title, className }: IProps) => {
  const { tenant } = useDataroomTenantContext();
  const pathname = usePathname();

  return (
    <GetStartedButtonComponent
      title={ title }
      className={ className }
      url={ dataroomUrl(tenant).getRegisterUrl(
        dataroomUrl(tenant).getUrl(pathname),
      ) }
    />
  );
};

export default GetStartedButton;
